<template>
  <svg
    class="font-icon"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1789_61522)">
      <path
        d="M10.9501 5.27006V6.05006C11.4601 6.05006 11.9501 6.05006 12.5101 6.05006V4.05006C12.5072 3.99808 12.5153 3.94608 12.5338 3.89745C12.5524 3.84883 12.581 3.80467 12.6179 3.76786C12.6547 3.73105 12.6988 3.70242 12.7474 3.68385C12.7961 3.66527 12.8481 3.65716 12.9001 3.66006H16.0201C16.072 3.65716 16.124 3.66527 16.1727 3.68385C16.2213 3.70242 16.2654 3.73105 16.3023 3.76786C16.3391 3.80467 16.3677 3.84883 16.3863 3.89745C16.4048 3.94608 16.4129 3.99808 16.4101 4.05006V6.36006C16.9101 6.36006 17.4101 6.48006 17.9701 6.56006V2.78006L16.6201 1.45006L14.4401 0.560059L12.2501 1.41006L10.9501 2.78006V4.49006M10.6801 6.64006C9.0302 7.40238 7.46213 8.33048 6.00005 9.41006C3.78465 11.0443 1.81467 12.9874 0.150052 15.1801L5.19625e-05 15.3301V16.3301C-0.00393802 16.5322 0.0324308 16.7331 0.10703 16.921C0.181628 17.1088 0.292958 17.28 0.434502 17.4243C0.576047 17.5686 0.744962 17.6833 0.931359 17.7616C1.11776 17.8398 1.31789 17.8801 1.52005 17.8801H3.46005V17.7601C4.52608 15.4864 5.86965 13.3534 7.46005 11.4101C8.92475 9.63567 10.6043 8.05018 12.4601 6.69006C11.7701 6.64006 11.2201 6.64006 10.6801 6.64006ZM13.7601 6.76006C11.6057 8.14518 9.69354 9.87489 8.10005 11.8801C6.61375 13.7282 5.34539 15.7415 4.32005 17.8801H8.57005V17.7601C9.30262 15.5697 10.2682 13.4643 11.4501 11.4801C12.4902 9.85444 13.6607 8.31605 14.9501 6.88006C14.5701 6.80006 14.1801 6.80006 13.7601 6.76006ZM8.65005 6.76006C7.53171 6.91569 6.42566 7.1496 5.34005 7.46006C4.18677 7.75881 3.07249 8.19177 2.02005 8.75006C1.38689 9.09274 0.787559 9.49453 0.230052 9.95006L5.19625e-05 10.1501V14.1501C1.61045 12.1348 3.46843 10.3306 5.53005 8.78006C6.5245 8.05088 7.56685 7.38939 8.65005 6.80006V6.76006ZM15.9501 6.88006C14.5304 8.41983 13.2645 10.0944 12.1701 11.8801C11.0292 13.7723 10.1002 15.7844 9.40005 17.8801H13.2201V17.8001C13.6101 16.0501 14.1101 14.3301 14.6601 12.6501C15.3218 10.7239 16.0863 8.83451 16.9501 6.99006L15.9501 6.88006ZM17.7001 7.11006C16.8401 8.98006 16.0701 10.9301 15.4001 12.8801C14.8901 14.4001 14.4501 15.9601 14.0801 17.5201C14.0694 17.5613 14.0683 17.6045 14.0769 17.6463C14.0854 17.6881 14.1034 17.7273 14.1295 17.7611C14.1555 17.7948 14.1889 17.8222 14.2271 17.8411C14.2654 17.86 14.3074 17.8699 14.3501 17.8701H16.4201C16.6205 17.8714 16.8192 17.833 17.0048 17.7572C17.1904 17.6814 17.3591 17.5697 17.5013 17.4284C17.6435 17.2871 17.7564 17.1191 17.8334 16.9341C17.9104 16.749 17.9501 16.5505 17.9501 16.3501V7.11006H17.7001Z"
      />
      <path
        d="M7.42997 2.59984L6.46997 2.01984V1.08984L7.42997 1.66984V2.59984Z"
      />
      <path
        d="M7.42997 3.90014L6.46997 3.32014V2.39014L7.42997 2.97014V3.90014Z"
      />
      <path
        d="M7.42997 5.17992L6.46997 4.59992V3.66992L7.42997 4.24992V5.17992Z"
      />
      <path
        d="M6.48 5L7.48 5.54V6.28C7.3247 6.26857 7.17422 6.22103 7.04053 6.14117C6.90685 6.06131 6.79367 5.95133 6.71 5.82C6.61367 5.70868 6.5431 5.57746 6.50334 5.43571C6.46359 5.29396 6.45562 5.14518 6.48 5Z"
      />
      <path
        d="M8.73003 4.97998L7.78003 5.52998V6.26998C7.93448 6.25594 8.08355 6.20616 8.21545 6.12459C8.34735 6.04302 8.45847 5.93189 8.54003 5.79998C8.6294 5.68533 8.69269 5.55256 8.72551 5.41094C8.75832 5.26933 8.75986 5.12226 8.73003 4.97998Z"
      />
      <path
        d="M7.77002 2.58008L8.73002 2.01008V1.08008L7.77002 1.66008V2.58008Z"
      />
      <path
        d="M7.77002 3.87988L8.73002 3.30988V2.37988L7.77002 2.95988V3.87988Z"
      />
      <path
        d="M7.77002 5.17016L8.73002 4.59016V3.66016L7.77002 4.24016V5.17016Z"
      />
      <path
        d="M2.68001 2.22002L1.26001 1.38002V0.0200195L2.68001 0.86002V2.22002Z"
      />
      <path
        d="M2.68001 4.12992L1.26001 3.28992V1.91992L2.68001 2.75992V4.12992Z"
      />
      <path d="M2.68001 6.0098L1.26001 5.1698V3.7998L2.68001 4.6398V6.0098Z" />
      <path
        d="M1.26998 5.75L2.66998 6.55V7.64C2.44373 7.61552 2.22579 7.54088 2.03204 7.42151C1.83829 7.30215 1.6736 7.14107 1.54998 6.95C1.42212 6.78061 1.33115 6.58632 1.28293 6.37965C1.2347 6.17297 1.23029 5.95848 1.26998 5.75Z"
      />
      <path
        d="M4.57994 5.72021L3.18994 6.52021V7.61021C3.42036 7.58342 3.64143 7.50356 3.83577 7.37689C4.0301 7.25022 4.19241 7.08021 4.30994 6.88021C4.4323 6.71582 4.51943 6.52796 4.56588 6.32837C4.61234 6.12877 4.61713 5.92174 4.57994 5.72021Z"
      />
      <path d="M3.17004 2.21L4.58004 1.36V0L3.17004 0.84V2.21Z" />
      <path
        d="M3.17004 4.11016L4.58004 3.27016V1.91016L3.17004 2.75016V4.11016Z"
      />
      <path
        d="M3.17004 5.99004L4.58004 5.15004V3.79004L3.17004 4.63004V5.99004Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_1789_61522">
        <rect width="17.95" height="17.87" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "ExploitationMenuIcon",
};
</script>
